import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle r="24.5" id="$" transform="matrix(-1 0 0 1 25 25)" fill="#fff" stroke="#EAEAEA" /><path id="!" fill="#000" d="M28.65 20.36a1 1 0 00-1.48-.88l-8.6 4.67a1 1 0 000 1.75l8.6 4.67a1 1 0 001.48-.88v-9.33z" /></svg>);